import { useViewContext, CREATIVE_LIBRARY_VIEWS } from '../../contexts/ViewContext';
import { useAssetsQueryContext } from '../../contexts/AssetsQueryContext';
import { FolderBreadcrumbs } from 'ui/indexPages/folders/folderBreadcrumbs';
import { Table } from '../index/tableView/Table';
import { Cards } from '../index/cardView/Cards';
import { PanelControls } from './components/PanelControls';
import { FullWidth } from 'ui/utility/fullWidth';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const TableViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const PanelViewList = () => {
  const { activeView } = useViewContext();

  const { currentFolder, rootFolderId } = useAssetsQueryContext();

  const isTableView = activeView === CREATIVE_LIBRARY_VIEWS.TABLE;

  return (
    <Container>
      <PanelControls />
      {!!currentFolder?.ancestors.length && currentFolder.id && (
        <FullWidth>
          <FolderBreadcrumbs
            folderAncestors={[
              ...currentFolder.ancestors,
              { id: currentFolder.id, name: currentFolder?.name },
            ]}
            rootFolderId={rootFolderId}
          />
        </FullWidth>
      )}

      <TableViewContainer>{isTableView ? <Table /> : <Cards />}</TableViewContainer>
    </Container>
  );
};
